<template>
  <v-card class="mx-4 mb-3">
    <v-tabs left v-model="selectedTab" slider-color="#227598" class="mb-2">
                      <v-tab
                        v-for="tab in tabs"
                        :key="tab.id"
                        style="font-size:20px!important;"
                      >{{ tab.name }}</v-tab>
                    </v-tabs>
                    <businessRules v-show="selectedTab == 1"></businessRules>
  </v-card>
</template>

<script>
import VPage from "../../layouts/Default.vue";
import axios from "axios";
import Bus from "../../bus";
import zigZag from "../../components/ZigZag.vue";
import businessRules from "./BusinessRulesManagement.vue";

export default {
  name: "BOSS40Management",

  components: {
    VPage,
    businessRules
  },

  data: () => ({
   tabs: [
      { id: 1, name: "General" },
      { id: 2, name: "Business Rules" }
    ],
    selectedTab:null
  }),
  mounted(){
this.initialize()
  },
  methods: {
      async initialize(){
          this.selectedTab = await 1
        //   this.selectedTab.splice()
      }
  }}
</script>

<style scoped>

</style>
